// ************************ images 2019 - 09/02/2019
import img20191 from "../../../assets/img/img-pickleball/20190209/imgPickleball-2019-01-608x236.jpg";
import img20192 from "../../../assets/img/img-pickleball/20190209/imgPickleball-2019-02-604x288.jpg";
import img20193 from "../../../assets/img/img-pickleball/20190209/imgPickleball-2019-03-604x140.jpg";
import img20194 from "../../../assets/img/img-pickleball/20190209/imgPickleball-2019-04-262x306.jpg";
import img20195 from "../../../assets/img/img-pickleball/20190209/imgPickleball-2019-05-240x304.jpg";
import img20196 from "../../../assets/img/img-pickleball/20190209/imgPickleball-2019-06-1200x1600.jpg";
import img20197 from "../../../assets/img/img-pickleball/20190209/imgPickleball-2019-07-1824x1368.jpg";
import img20198 from "../../../assets/img/img-pickleball/20190209/imgPickleball-2019-08-1824x1368.jpg";
import img20199 from "../../../assets/img/img-pickleball/20190209/imgPickleball-2019-09-1824x1368.jpg";
import img201910 from "../../../assets/img/img-pickleball/20190209/imgPickleball-2019-10-1591x851.jpg";
// ************************ images 2020 - 23/11/2019
import img20201 from "../../../assets/img/img-pickleball/20191123/imgPickleball-2020-01-606x228.jpg";
import img20202 from "../../../assets/img/img-pickleball/20191123/imgPickleball-2020-02-604x312.jpg";
import img20203 from "../../../assets/img/img-pickleball/20191123/imgPickleball-2020-03-290x248.jpg";
import img20204 from "../../../assets/img/img-pickleball/20191123/imgPickleball-2020-04-260x248.jpg";
import img20205 from "../../../assets/img/img-pickleball/20191123/imgPickleball-2020-05-960x720.jpg";
import img20206 from "../../../assets/img/img-pickleball/20191123/imgPickleball-2020-06-960x720.jpg";
import img20207 from "../../../assets/img/img-pickleball/20191123/imgPickleball-2020-07-960x720.jpg";
import img20208 from "../../../assets/img/img-pickleball/20191123/imgPickleball-2020-08-960x720.jpg";
import img20209 from "../../../assets/img/img-pickleball/20191123/imgPickleball-2020-09-960x720.jpg";
import img202010 from "../../../assets/img/img-pickleball/20191123/imgPickleball-2020-10-960x720.jpg";
import img202011 from "../../../assets/img/img-pickleball/20191123/imgPickleball-2020-11-960x720.jpg";
import img202012 from "../../../assets/img/img-pickleball/20191123/imgPickleball-2020-12-960x720.jpg";
import img202013 from "../../../assets/img/img-pickleball/20191123/imgPickleball-2020-13-960x720.jpg";
// ************************ images 2022 - 20/11/2021
import img20221 from "../../../assets/img/img-pickleball/20211120/imgPickleball-2022-01-566x234.jpg";
import img20222 from "../../../assets/img/img-pickleball/20211120/imgPickleball-2022-02-560x204.jpg";
import img20223 from "../../../assets/img/img-pickleball/20211120/imgPickleball-2022-03-348x266.jpg";
// ************************ images 2023 - 22/11/2022
import img20231 from "../../../assets/img/img-pickleball/20221122/imgPickleball-2023-01-472x288.jpg";
import img20232 from "../../../assets/img/img-pickleball/20221122/imgPickleball-2023-02-220x278.jpg";
import img20233 from "../../../assets/img/img-pickleball/20221122/imgPickleball-2023-03-212x268.jpg";
// ************************ images 2024 - 11/11/2023
import img20241 from "../../../assets/img/img-pickleball/20231111/imgPickleball-2024-01-1156x500.jpg";
import img20242 from "../../../assets/img/img-pickleball/20231111/imgPickleball-2024-02-953x600.jpg";
import img20243 from "../../../assets/img/img-pickleball/20231111/imgPickleball-2024-03-967x600.jpg";
import img20244 from "../../../assets/img/img-pickleball/20231111/imgPickleball-2024-04-812x600.jpg";
import img20245 from "../../../assets/img/img-pickleball/20231111/imgPickleball-2024-05-650x325.jpg";
import img20246 from "../../../assets/img/img-pickleball/20231111/imgPickleball-2024-06-740x325.jpg";
import img20247 from "../../../assets/img/img-pickleball/20231111/imgPickleball-2024-07-795x365.jpg";
import img20248 from "../../../assets/img/img-pickleball/20231111/imgPickleball-2024-08-900x455.jpg";
import img20249 from "../../../assets/img/img-pickleball/20231111/imgPickleball-2024-09-800x600.jpg";
// ************************ images 2025 - 23/11/2024
import img202501 from "../../../assets/img/img-pickleball/20241123/imgPickleball-202501-01-425x600.jpg";
import img202502 from "../../../assets/img/img-pickleball/20241123/imgPickleball-202501-02-1000x393.png";
import img202503 from "../../../assets/img/img-pickleball/20241123/imgPickleball-202501-03-800x645.png";
import img202504 from "../../../assets/img/img-pickleball/20241123/imgPickleball-202501-04-800x506.png";
import img202505 from "../../../assets/img/img-pickleball/20241123/imgPickleball-202501-05-900x425.png";
import img202506 from "../../../assets/img/img-pickleball/20241123/imgPickleball-202501-06-800x498.png";
import img202507 from "../../../assets/img/img-pickleball/20241123/imgPickleball-202501-07-800x517.png";
import img202508 from "../../../assets/img/img-pickleball/20241123/imgPickleball-202501-08-900x440.png";
import img202509 from "../../../assets/img/img-pickleball/20241123/imgPickleball-202501-09-800x474.png";
import img202510 from "../../../assets/img/img-pickleball/20241123/imgPickleball-202501-10-900x404.png";
import img202511 from "../../../assets/img/img-pickleball/20241123/imgPickleball-202501-11-600x619.png";
// ************************ images 2025 - 08/02/2025
import img202512 from "../../../assets/img/img-pickleball/20250208/imgPickleball-202502-01-1238x1750.jpg";
import img202513 from "../../../assets/img/img-pickleball/20250208/imgPickleball-202502-02-911x320.png";
import img202514 from "../../../assets/img/img-pickleball/20250208/imgPickleball-202502-03-645x520.png";
import img202515 from "../../../assets/img/img-pickleball/20250208/imgPickleball-202502-04-700x625.png";
import img202516 from "../../../assets/img/img-pickleball/20250208/imgPickleball-202502-05-619x309.png";
import img202517 from "../../../assets/img/img-pickleball/20250208/imgPickleball-202502-06-710x380.jpg";
import img202518 from "../../../assets/img/img-pickleball/20250208/imgPickleball-202502-07-800x400.png";
import img202519 from "../../../assets/img/img-pickleball/20250208/imgPickleball-202502-08-690x570.png";
import img202520 from "../../../assets/img/img-pickleball/20250208/imgPickleball-202502-09-750x595.png";
import img202521 from "../../../assets/img/img-pickleball/20250208/imgPickleball-202502-10-880x475.png";
import img202522 from "../../../assets/img/img-pickleball/20250208/imgPickleball-202502-11-1015x1292.png";
// ************************ images 2026 - 22/11/2025
import img202600 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-00-1239x1756.png";
import img202601 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-01-686x962.png";
import img202602 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-02-454x211.png";
import img202603 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-03-454x268.png";
import img202604 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-04-454x358.png";
import img202605 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-05-454x354.png";
import img202606 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-06-454x432.png";
import img202607 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-07-454x456.png";
import img202608 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-08-454x291.png";
import img202609 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-09-454x396.png";
import img202610 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-10-454x197.png";
import img202611 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-11-454x202.png";
import img202612 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-12-612x266.png";
import img202613 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-13-454x301.png";
import img202614 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-14-454x202.png";
import img202615 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-15-454x231.png";
import img202616 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-16-454x214.png";
import img202617 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-17-454x204.png";
import img202618 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-18-454x155.png";
import img202619 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-19-454x215.png";
import img202620 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-20-454x252.png";
import img202621 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-21-454x179.png";
import img202622 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-22-454x227.png";
import img202623 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-23-454x273.png";
import img202624 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-24-454x316.png";
import img202625 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-25-454x239.png";
import img202626 from "../../../assets/img/img-pickleball/20251122/imgPickleball-202511-26-454x257.png";
// ************************ images 2026 - 31/01/2026
import img202627 from "../../../assets/img/img-pickleball/20260131/imgPickleball-202601-00-1131x1600.jpg";
import img202628 from "../../../assets/img/img-pickleball/20260131/imgPickleball-202601-01-750x814.png";
import img202629 from "../../../assets/img/img-pickleball/20260131/imgPickleball-202601-02-1050x414.jpg";
import img202630 from "../../../assets/img/img-pickleball/20260131/imgPickleball-202601-03-1184x280.jpg";
import img202631 from "../../../assets/img/img-pickleball/20260131/imgPickleball-202601-04-1082x324.jpg";
import img202632 from "../../../assets/img/img-pickleball/20260131/imgPickleball-202601-05-750x522.jpg";
import img202633 from "../../../assets/img/img-pickleball/20260131/imgPickleball-202601-06-540x510.jpg";
import img202634 from "../../../assets/img/img-pickleball/20260131/imgPickleball-202601-07-698x550.jpg";

const breakpoints = [1080, 640, 384, 256, 128, 96, 64, 48];

const tabPickleball = [
  {
    id: 1,
    season: "2019",
    sessions: [
      {
        date: "09/02/2019",
        edition: 1,
        num: 17,
        comment:
          "🏆 Vainqueurs : Lonny JARILLO et Maël CHAPUIS - Finalistes : Yvan BESSON / Romain GOYON",
        images: [
          { img: img20191, width: "608", height: "236" },
          { img: img20192, width: "604", height: "288" },
          { img: img20193, width: "604", height: "140" },
          { img: img20194, width: "262", height: "306" },
          { img: img20195, width: "240", height: "304" },
          { img: img20196, width: "1200", height: "1600" },
          { img: img20197, width: "1824", height: "1368" },
          { img: img20198, width: "1824", height: "1368" },
          { img: img20199, width: "1824", height: "1368" },
          { img: img201910, width: "1591", height: "851" },
        ],
      },
    ],
  },
  {
    id: 2,
    season: "2020",
    sessions: [
      {
        date: "23/11/2019",
        edition: 2,
        num: 24,
        comment:
          "🏆 Vainqueurs : Cédric et Evan JARILLO - Finalistes : Jérôme et Arthur PANIE",
        images: [
          { img: img20201, width: "606", height: "228" },
          { img: img20202, width: "604", height: "312" },
          { img: img20203, width: "200", height: "248" },
          { img: img20204, width: "260", height: "248" },
          { img: img20205, width: "960", height: "720" },
          { img: img20206, width: "960", height: "720" },
          { img: img20207, width: "960", height: "720" },
          { img: img20208, width: "960", height: "720" },
          { img: img20209, width: "960", height: "720" },
          { img: img202010, width: "960", height: "720" },
          { img: img202011, width: "960", height: "720" },
          { img: img202012, width: "960", height: "720" },
          { img: img202013, width: "960", height: "720" },
        ],
      },
    ],
  },
  {
    id: 3,
    season: "2021",
    sessions: [
      {
        date: "06/02/2021",
        edition: 0,
        num: 0,
        comment: "Annulée pour cause de COVID",
        images: [{}],
      },
      {
        date: "21/11/2020",
        edition: 0,
        num: 0,
        comment: "Annulée pour cause de COVID",
        images: [{}],
      },
    ],
  },
  {
    id: 4,
    season: "2022",
    sessions: [
      {
        date: "20/11/2021",
        edition: 3,
        num: 15,
        comment:
          "🏆 Vainqueurs : Arnaud et Lenny GOLLIN - Finalistes : Stéphane DEVOUCOUX / Cindy AMORIM",
        images: [
          { img: img20221, width: "566", height: "234" },
          { img: img20222, width: "560", height: "204" },
          { img: img20223, width: "348", height: "266" },
        ],
      },
    ],
  },
  {
    id: 5,
    season: "2023",
    sessions: [
      {
        date: "22/11/2022",
        edition: 4,
        num: 23,
        comment:
          "🏆 Vainqueurs : Cédric et Lonny JARILLO - Finalistes : Lenny GOLLIN / Kenan DEMIRAY",
        images: [
          { img: img20231, width: "472", height: "288" },
          { img: img20232, width: "220", height: "278" },
          { img: img20233, width: "212", height: "268" },
        ],
      },
    ],
  },
  {
    id: 6,
    season: "2024",
    sessions: [
      {
        date: "11/11/2023",
        edition: 5,
        num: 26,
        comment:
          "🏆 Vainqueurs : Stéphane DEVOUCOUX / Antoine SCHULLER - Finalistes : Laurent BLONDEAU / XX",
        images: [
          { img: img20241, width: "1156", height: "500" },
          { img: img20242, width: "953", height: "600" },
          { img: img20243, width: "967", height: "600" },
          { img: img20244, width: "812", height: "600" },
          { img: img20245, width: "650", height: "325" },
          { img: img20246, width: "740", height: "325" },
          { img: img20247, width: "795", height: "365" },
          { img: img20248, width: "900", height: "455" },
          { img: img20249, width: "800", height: "600" },
        ],
      },
    ],
  },
  {
    id: 7,
    season: "2025",
    sessions: [
      {
        date: "08/02/2025",
        edition: 7,
        num: 20,
        comment:
          "🏆 Vainqueurs : Charles BERTRAND / Amaël CANIOU - Finalistes : Patrick / Marie-Anne GRS Mâcon 🏆 Consolante : Vainqueurs : Benjamin Clair / Simon Monavon - Finalistes : Florence Poncet / Yan Meyer}",
        images: [
          { img: img202512, width: "1238", height: "1750" },
          { img: img202513, width: "911", height: "320" },
          { img: img202514, width: "645", height: "520" },
          { img: img202515, width: "700", height: "625" },
          { img: img202516, width: "619", height: "309" },
          { img: img202517, width: "710", height: "380" },
          { img: img202518, width: "800", height: "400" },
          { img: img202519, width: "690", height: "570" },
          { img: img202520, width: "750", height: "595" },
          { img: img202521, width: "880", height: "475" },
          { img: img202522, width: "1015", height: "1292" },
        ],
      },
      {
        date: "23/11/2024",
        edition: 6,
        num: 42,
        comment:
          "🏆 Vainqueurs : Charles BERTRAND / Amaël CANIOU - Finalistes : Stéphane DEVOUCOUX / Julien VANNIER",
        images: [
          { img: img202501, width: "425", height: "600" },
          { img: img202502, width: "1000", height: "393" },
          { img: img202503, width: "800", height: "645" },
          { img: img202504, width: "800", height: "506" },
          { img: img202505, width: "900", height: "425" },
          { img: img202506, width: "800", height: "498" },
          { img: img202507, width: "800", height: "517" },
          { img: img202508, width: "900", height: "440" },
          { img: img202509, width: "800", height: "474" },
          { img: img202510, width: "900", height: "404" },
          { img: img202511, width: "600", height: "619" },
        ],
      },
    ],
  },
  {
    id: 8,
    season: "2026",
    sessions: [
      {
        date: "31/01/2026",
        edition: 9,
        num: 30,
        comment: "",
        images: [
          { img: img202627, width: "1131", height: "1600" },
          { img: img202628, width: "750", height: "814" },
          { img: img202629, width: "1050", height: "414" },
          { img: img202630, width: "1184", height: "280" },
          { img: img202631, width: "1082", height: "324" },
          { img: img202632, width: "750", height: "522" },
          { img: img202633, width: "540", height: "510" },
          { img: img202634, width: "698", height: "550" },
        ],
      },
      {
        date: "22/11/2025",
        edition: 8,
        num: 33,
        comment:
          "🏆 Vainqueurs : Maël LAURENT / Frédéric GAUVRIT - Finalistes : Constant PERRIER / Valentin RABUEL",
        images: [
          { img: img202600, width: "1239", height: "1756" },
          { img: img202601, width: "686", height: "962" },
          { img: img202602, width: "454", height: "211" },
          { img: img202603, width: "454", height: "268" },
          { img: img202604, width: "454", height: "358" },
          { img: img202605, width: "454", height: "354" },
          { img: img202606, width: "454", height: "432" },
          { img: img202607, width: "454", height: "456" },
          { img: img202608, width: "454", height: "291" },
          { img: img202609, width: "454", height: "396" },
          { img: img202610, width: "454", height: "197" },
          { img: img202611, width: "454", height: "202" },
          { img: img202612, width: "612", height: "266" },
          { img: img202613, width: "454", height: "301" },
          { img: img202614, width: "454", height: "202" },
          { img: img202615, width: "454", height: "231" },
          { img: img202616, width: "454", height: "214" },
          { img: img202617, width: "454", height: "204" },
          { img: img202618, width: "454", height: "155" },
          { img: img202619, width: "454", height: "215" },
          { img: img202620, width: "454", height: "252" },
          { img: img202621, width: "454", height: "179" },
          { img: img202622, width: "454", height: "227" },
          { img: img202623, width: "454", height: "273" },
          { img: img202624, width: "454", height: "316" },
          { img: img202625, width: "454", height: "239" },
          { img: img202626, width: "454", height: "257" },
        ],
      },
    ],
  },
];

const photosPickleball = tabPickleball.map((photo) => ({
  id: photo.id,
  season: photo.season,
  sessions: photo.sessions.map((session) => {
    return {
      date: session.date,
      edition: session.edition,
      num: session.num,
      comment: session.comment,
      images: session.images.map((image) => {
        return {
          src: image.img,
          width: image.width,
          height: image.height,
          srcSet: breakpoints.map((breakpoint) => {
            const height = Math.round(
              (image.height / image.width) * breakpoint,
            );
            return {
              src: image.img,
              width: breakpoint,
              height: height,
            };
          }),
        };
      }),
    };
  }),
}));

export default photosPickleball;
